<template>
  <div>
    <div class="container alturaMinima">
      <Dialog header="Medico Especialista" :visible="displayModal" :modal="true" class="modalVista" :closeOnEscape="true"
        :dismissableMask="true" :closable="false" v-if="especialistaEnDetail" min-width="50vw">
        <div style="display: flex;flex-wrap: wrap;background-color: #e8e8e8;height:105px">
          <div style="height:100%;width:100%;display: flex;align-items: center;">
            <h4 class="p-pa-3 nombreApellido">
              {{ especialistaEnDetail.nombres | todasLasPrimerasMayusculas }}
              {{ especialistaEnDetail.apellidos | todasLasPrimerasMayusculas }}
            </h4>
          </div>
        </div>
        <p class="p-mb-1 p-mt-3">
          <i class="pi pi-envelope p-mr-3" />
          <a @click="openBasic2">
            {{
              especialistaEnDetail.email.toLowerCase()
            }}</a>
        </p>
        <p class="p-mb-2">
          <i class="mdi mdi-phone p-mr-2" />
          <a :href="'tel:+' + especialistaEnDetail.telefono">{{
            especialistaEnDetail.telefono
          }}</a>
        </p>
        <template #footer>
          <Button :label="$t('messages.sendMessage')" icon="pi pi-envelope" @click="openBasic2" autofocus name="enviar_mail" />
          <Button :label="$t('messages.close')" icon="pi pi-check" @click="displayModal = false" autofocus name="salir" />
        </template>
      </Dialog>
      <Dialog :header="$t('messages.messageToSurgeon')" :visible.sync="displayBasic2">
        <SendMail
          :nombreespecialista="especialistaEnDetail ? `${especialistaEnDetail.nombres.toUpperCase()} ${especialistaEnDetail.apellidos.toUpperCase()} ` : ''"
          :correoespecialista="especialistaEnDetail ? especialistaEnDetail.email.toLowerCase() : ''"
          :onSave="() => { displayBasic2 = false }" />
      </Dialog>
      <div class="p-grid">
        <div v-for="(especialidad, index) in especialidades" :key="index" class="p-col-12">
          <h1 v-if="medicosFiltrados(especialidad.id).length > 0">{{ especialidad.nombre | todasLasPrimerasMayusculas }}
          </h1>
          <div style="display: flex;flex-wrap: wrap;justify-content: space-around;">
            <transition v-for="(medico, index) in medicosFiltrados(especialidad.id)" :key="index" name="fade">
              <div class="p-mt-2 p-shadow-2 cardMia">
                <div class="p-grid" style="height:100%">
                  <div class="p-col-12 p-pt-4"
                    style="height:100%;display:flex;flex-direction: column;justify-content: space-between;">
                    <h4 class="nombreGrid">
                      {{ medico.nombres.toUpperCase() }}
                      {{ medico.apellidos.toUpperCase() }}
                    </h4>
                    <p class="descripcion-especialidad">
                      {{ getEspecialidadDescripcion(medico, especialidad.id) }}
                    </p>
                    <p class="p-mb-1 p-mt-1 link-main" @click="enviarMensaje(medico)">
                      <i class="pi pi-envelope p-mr-3" />
                      <a>
                        {{ $t("messages.sendMessage") }}
                      </a>
                    </p>
                    <!-- <p class="p-mb-2"> 
                      <i class="mdi mdi-phone p-mr-2" />
                      <a :href="'tel:+' + medico.telefono">{{
                        medico.telefono
                      }}</a>
                    </p> -->
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EspecialidadesService from "../service/especialidades.service";
import UsuariosService from "../service/usuarios.service";
import SendMail from "./send_mail.vue";

export default {
  metaInfo: {
    title: 'Especialistas - QualityCare',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Especialistas - QualityCare',
        content: 'Se muestra el listado de especialistas para que los usuarios puedan contactarlos y solicitar sus servicios',
      },
    ],
  },
  name: "ListadoEspecialistas",
  components: {
    SendMail,
  },
  data() {
    return {
      especialidadesService: null,
      usuariosService: null,
      especialidades: [],
      medicos: [],
      stringMedico: "",
      displayModal: false,
      especialistaEnDetail: null,
      urlAvatar: "",
      displayBasic2: false,
    };
  },
  created() {
    this.urlAvatar = process.env.VUE_APP_API_AVATAR;
    this.especialidadesService = new EspecialidadesService();
    this.usuariosService = new UsuariosService();
  },
  mounted() {
    this.recuperarEspecialidades();
    this.recuperarEspecialistas();
  },
  methods: {
    getEspecialidadDescripcion(medico, idEspecialidad) {
      let especialidadFiltered = medico.especialidades.find((especialidad) => {
        return especialidad.id_especialidad === idEspecialidad
      });
      if (especialidadFiltered && especialidadFiltered.descripcion.trim() !== "") {
        return especialidadFiltered.descripcion;
      } else if (especialidadFiltered && especialidadFiltered.descripcion_especialidad.trim() !== "") {
        return especialidadFiltered.descripcion_especialidad;
      }
      return "";
    },
    recuperarEspecialidades() {
      this.especialidadesService
        .allEspecialidades()
        .then((result) => {
          if (result.data.data) {
            this.especialidades = [...result.data.data];
          }
          //tomar los no ocultos y ordenar por orden
          this.especialidades = this.especialidades.filter((especialidad) => especialidad.ocultar_en_listado === 0).sort((a, b) => {
            if (a.orden < b.orden) {
              return -1;
            }
            if (a.orden > b.orden) {
              return 1;
            }
            return 0;
          });
        })
        .catch((err) => {
          console.log(err);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error al cargar especialidades",
            life: 3000,
          });
        });
    },
    recuperarEspecialistas() {
      this.usuariosService
        .allEspecialistas()
        .then((result) => {
          if (result.data.data) {
            this.medicos = result.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error al recuperar especialistas",
            life: 3000,
          });
        });
    },
    medicosFiltrados(idEspecialidad) {
      return this.medicos.filter((medico) => {
        return medico.ocultar_en_especialistas === 0 && medico.especialidades.find((especialidad) => especialidad.id_especialidad === idEspecialidad)
      });
    },
    verMas(event) {
      this.especialistaEnDetail = event;
      this.displayModal = true;
    },
    enviarMensaje(event) {
      this.especialistaEnDetail = event;
      this.openBasic2();
    },
    obtenerYear(fecha) {
      return new Date(fecha).getFullYear();
    },
    openBasic2() {
      this.displayBasic2 = true;
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  text-align: center;
  padding: 5px 0px;
  background-color: #083078;
  color: white;
  font-size: 31px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin: 0px;
}

.subcontainer {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 20px 300px;
  background-color: #ffffff;
  justify-content: space-around;

  .cardPropia {
    text-align: center;
    width: 400px;
    margin-bottom: 35px;
  }
}

h3 {
  font-size: 18px;
  margin: 0px;
}

h4 {
  font-size: 15px;
  font-weight: bold;
  color: #083078;
  margin-top: 10px;
}

.boton-enlace {
  text-align: center;
  background-color: #083078;
  padding: 10px 0px;
  color: white;
  user-select: none;
  width: fit-content;
  height: fit-content;
  border-radius: 3px;
  margin-top: 40px;
  transition: 0.5s all;
  cursor: pointer;

  a {
    color: white;
    font-size: 16px;
    width: 100%;
    padding: 10px 20px;
  }
}

.boton-enlace:hover {
  background-color: #2B86D9;
}

@media screen and (max-width: 1470px) {
  .subcontainer {
    padding: 0px 10px;
  }
}


.container {
  padding: 20px 300px;
}

.divAutocomplete {
  width: 600px;
}

.cardMia {
  background: white;
  min-height: 267px;
  padding: 0px;
  border-radius: 5px;
  overflow: hidden;
  transition: 0.5s all;
  width: 24%;
  padding-inline: 30px;
}

.cardMia:hover {
  background: #ededed;
  cursor: pointer;
}

.descripcion-especialidad {
  font-size: 15px;
  color: #4d4d4d;
  text-align: justify;
}

.imagenAvatar {
  height: 100%;
  width: auto;
  margin-top: 10px;
  margin-left: 10px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.modalVista {
  min-width: 40vw;
}

.nombreEspecialidad {
  font-size: 19px;
  font-weight: 700;
}

.nombreApellido {
  font-size: 30px;
  padding-inline: 30px;
}

.containerFotoGrid {
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  overflow: hidden;
  justify-content: center;
}

.nombreGrid {
  color: #005fb3;
  font-weight: 700;
  font-size: 1.3rem;
}

.link-main {
  cursor: pointer;
  transition: 0.5s all;
}

.link-main:hover {
  font-weight: 700;
}

@media screen and (max-width: 1400px) {
  .divAutocomplete {
    width: 100%;
  }

  .container {
    padding: 20px 40px;
  }
}

@media screen and (max-width: 800px) {
  .divAutocomplete {
    width: 100%;
  }

  .cardMia {
    width: 100%;
    margin-left: 0px;
    //height: 200px;
  }

  .modalVista {
    width: 90vw;
  }

  .container {
    padding: 20px 10px;
  }
}
</style>
